import { toUtcSeconds } from '@/utils/utcTime'
import { sma, ema } from './engine.js'

export function detect(sanitizedCandles, config) {
  if (!Array.isArray(sanitizedCandles) || sanitizedCandles.length === 0 || !config.mas || config.mas.length === 0) {
    return null
  }

  const mas = []
  for (const ma of config.mas) {
    if (!ma.active) continue
    const values = ma.type === 'sma' ? sma(sanitizedCandles, ma.period) : ema(sanitizedCandles, ma.period)
    const points = []
    for (let i = 0; i < values.length; i++) {
      if (values[i] == null || !Number.isFinite(values[i])) continue
      points.push({ time: sanitizedCandles[i].time, value: values[i], type: ma.type, period: ma.period, color: ma.color, id: ma.id, lineStyle: ma.lineStyle, lineWidth: ma.lineWidth })
    }
    if (points.length > 0) mas.push(points)
  }

  return mas.length > 0 ? { mas } : null
}
